import React from "react";
import { readableCode, shown } from "../../utils/ediPresentation";

const STYLES = {
  INBOUND: "bg-blue-100 text-blue-800",
  OUTBOUND: "bg-violet-100 text-violet-800",
  PARSED: "bg-emerald-100 text-emerald-800",
  PARSE_FAILED: "bg-red-100 text-red-800",
  VERIFIED: "bg-emerald-100 text-emerald-800",
  MISSING: "bg-slate-100 text-slate-700",
  MISMATCH: "bg-red-100 text-red-800",
  MATCHED: "bg-emerald-100 text-emerald-800",
  PARTIAL_TRANSACTION_ACK: "bg-amber-100 text-amber-900",
  NO_997_EVIDENCE: "bg-slate-100 text-slate-700",
  HISTORICAL_BACKFILL: "bg-indigo-100 text-indigo-800",
  "Matched / Accepted": "bg-emerald-100 text-emerald-800",
  "Matched / Rejected": "bg-red-100 text-red-800",
  "Matched / Partial": "bg-amber-100 text-amber-900",
  "Matched / Outcome Unknown": "bg-slate-100 text-slate-700",
  "Pending Correlation": "bg-blue-100 text-blue-800",
  "Acknowledgement Not Found": "bg-slate-100 text-slate-700",
  "Source Not Found": "bg-slate-100 text-slate-700",
  "Source Excluded — Business Review": "bg-amber-100 text-amber-900",
  "Legacy Source Outside PortPilot Scope": "bg-slate-100 text-slate-700",
  "Ambiguous Acknowledgement": "bg-amber-100 text-amber-900",
  "Ambiguous Source": "bg-amber-100 text-amber-900",
};

export default function EdiStatusBadge({ value, label }) {
  const code = value || "";
  return (
    <span className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${STYLES[code] || "bg-slate-100 text-slate-700"}`}>
      {label || (code ? readableCode(code) : shown(null))}
    </span>
  );
}
